// src/layers/imagery/referenceOnTop.js
//
// Explore's with_reference (footprint restyle S-c4, DB 2026-11-03): the
// Sentinel-2 dataset whose entitled area GET /imagery/entitled should open in
// the mask, because it is what the map shows. Null otherwise, and the mask is
// the visual captures' alone.
//
// Sent only in two states, for the Sentinel-2 composite the reference lane
// draws at the cursor (resolveReferenceLane):
//   selection  the cursor is on a Sentinel-2 date: a Sentinel-2 chip was
//              clicked (ExploreTimeStrip sets the global cursor to its date);
//              a 10 cm chip moves the cursor off it, and the mask goes back
//   on top     no 10 cm layer is drawn (none in the stack, or every one
//              hidden or degraded), so the lane under them is the top layer
// Never in Compare: a pair is two pinned dates of a 10 cm series
// (enterCompareForDates looks in catalog.series; Sentinel-2 is in
// catalog.reference), each pane draws its own pinned 10 cm capture over its own
// reference lane, so a side never has Sentinel-2 on top (DB's question 3,
// answered no 2026-11-03).
import { resolveImageryStack, resolveReferenceLane } from "./resolveImageryStack";

/**
 * @param {{stack: object[], cursor: object, catalog: object, compareMode?: {enabled: boolean}|null}} state
 * @param {Date} [now]
 * @returns {string|null} the dataset_id to send as with_reference
 */
export function exploreWithReference({ stack, cursor, catalog, compareMode = null }, now = new Date()) {
  if (compareMode?.enabled || !catalog) return null;
  const drawn = resolveReferenceLane({ cursor, catalog }, now).find((s) => s.visible && !s.degraded && s.dataset_key);
  if (!drawn) return null;
  const refAcqs = (catalog.reference ?? []).flatMap((s) => s.acquisitions ?? []);
  const selected = refAcqs.some((a) => a.acquisition_date === cursor?.global_date);
  const tenCmDrawn = resolveImageryStack({ stack: stack ?? [], cursor, catalog: { series: catalog.series ?? [] } }, now)
    .some((s) => s.visible && !s.degraded && s.dataset_key);
  if (!selected && tenCmDrawn) return null;
  return refAcqs.find((a) => a.dataset_key === drawn.dataset_key)?.dataset_id ?? null;
}
